import React from 'react';
import PropsTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';

const MenuBlock = (props) => {
    const { header, subHeader } = props.data;
    const history = useHistory();
    return (
        <div className="menu-block-container">
            <h3 className="menu-header">{header}</h3>
            {subHeader.map((data, key) => (
                <Button
                    test_id={data.value}
                    type="link"
                    to="#"
                    onClick={() => {
                        if (data.other) {
                            window.open(data.link);
                        } else {
                            if (data.link === '/profile/detail') {
                                history.push(data.link, { index: 2 });
                            } else {
                                history.push(data.link);
                            }

                            window.location.reload(false);
                        }
                    }}
                    className="footerLinkText"
                    key={key}
                >
                    {data.value}
                </Button>
            ))}
        </div>
    );
};

MenuBlock.propsType = {
    data: PropsTypes.object.isRequired,
};

export default MenuBlock;
